import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {SalesForceCardFormService} from "./sales-force-card-form.service";
import {Actions, ofType} from "@ngrx/effects";
import {ReviewerActions} from "../../../store/actions/reviewer.actions";
import {StandaloneFormComponent} from "../standalone-form.component";
import {OpportunityIdValidatorService} from "../../services/opportunity-id-validator.service";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {NotificationService} from "../../services/notification.service";
import {Store} from "@ngrx/store";

@Component({
    selector: 'sales-force-card',
    templateUrl: './sales-force-card.template.html',
    styleUrls: ['./sales-force-card.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SalesForceCardComponent extends StandaloneFormComponent implements OnInit {

	@Input() opportunityId: string;
	@Input() readOnly: boolean;
	@Input() dataCompared: boolean = false;
	@Input() correlationId: string;

	@Output() onSend: EventEmitter<{ opportunityId: string }> = new EventEmitter();

	form: FormGroup;

	constructor(public formService: SalesForceCardFormService, private actions$: Actions,
				private opportunityIdValidatorService: OpportunityIdValidatorService, private notifications: NotificationService,
				private store: Store) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildStandaloneForm(this.opportunityId);

		if (this.opportunityId !== null) {
			this.opportunityIdValidatorService.addOpportunityId(this.opportunityId);
		}

		this.actions$.pipe(ofType(ReviewerActions.SEND_OPPORTUNITY_ID_SUCCESSFUL))
			.subscribe((result) => {
				this.opportunityIdValidatorService.addOpportunityId(result.opportunityId);
				this.notifications.success({text: 'Opportunity ID saved successfully'})
			});

		this.actions$.pipe(ofType(ReviewerActions.SEND_OPPORTUNITY_ID_FAILURE))
			.subscribe(() => {
				this.notifications.error({text: 'Error during saving opportunity ID'})
			});

		this.form.controls['opportunityId'].valueChanges.pipe(
			distinctUntilChanged(),
			debounceTime(500)
		).subscribe(value => {
			this.opportunityIdValidatorService.addOpportunityId(value);
		})
	}

	send() {
		this.formService.submit(() => {
			this.onSend.emit({
				opportunityId: this.form.controls['opportunityId'].value
			});
		}, null, null, () => this.formService.enableInputs());
	}

	onDataComparedChanged() {
		this.dataCompared = !this.dataCompared;

		this.store.dispatch(ReviewerActions.SET_DATA_COMPARED({
			dataCompared: this.dataCompared,
			orderCorrelationId: this.correlationId
		}));
	}

}
